export default __webpack_public_path__ + "media/images/projekktor-maccaco/maccaco-load-static-d674c60313beaddcbbc2e9740d98c8d8.png";